export default __webpack_public_path__ + "static/media/djlogo.c2622b73.svg";